import React from "react"

import Header from "../components/Header"
import Footer from "../components/Footer"

const Terminos = () => (
  <div>
    <Header showSearch={false} />
    <div className="max-w-7xl mx-auto pt-10">
      <h1 className="text-center text-4xl mb-10">Términos y Condiciones</h1>
      <main className="mx-auto" style={{ maxWidth: "70ch" }}>
        <p style={{ marginBottom: 10 }}>
          <strong>Organización</strong>: Navidad Pyme es un evento organizado
          por y para emprendedores (el &quot;Evento&quot; y/o &quot;Navidad
          Pyme&quot;). En este sentido, no hay una sola entidad detrás de su
          organización sino que trata de un esfuerzo mancomunado entre distintas
          empresas, que pretenden dar vitrina y fuerza de venta a las pymes de
          Chile en un contexto determinado.
        </p>
        <p style={{ marginBottom: 10 }}>
          {" "}
          <strong>Participación</strong>: El Evento cuenta con la participación
          de distintas empresas participantes (&quot;Empresas
          Participantes&quot;), qué se han adherido voluntariamente al mismo.
        </p>
        <p style={{ marginBottom: 10 }}>
          <strong>Objetivo</strong>: Si bien el objetivo del Evento es que las
          Empresas Participantes otorguen algún tipo de beneficio o descuento al
          público en general, lo anterior no es ni un requisito, ni una
          obligación para la participación de las mismas en el Evento.
        </p>
        <p style={{ marginBottom: 10 }}>
          <strong>Duración</strong>: El Evento comienza el 8 de junio de 2020, a
          las 00:00 hrs. y termina el 10 de junio de 2020, a las 23:59 hrs.
        </p>
        <p style={{ marginBottom: 10 }}>
          <strong>Responsabilidades</strong>: El Evento es una vitrina y un
          lugar de encuentro de todas las Empresas Participantes y los
          consumidores. Cada Empresa Participante es responsable de todas las
          ventas de que se hagan a través de sus canales. En este sentido, cada
          Empresa Participante debe contar con sus propios Términos y
          Condiciones, Políticas de Privacidad y Seguridad, Garantías, Políticas
          de Devolución, Condiciones de Entrega y similares, y por lo tanto, se
          hará cargo de los productos y/o servicios que ofrece durante el
          Evento. Por lo anterior, infórmese acerca de los términos y
          condiciones de cada Empresa Participante para conocer detalles de
          post-venta, plazos de entrega, devoluciones, cambios, costos de
          despacho, políticas de privacidad y seguridad del sitio.{" "}
          <strong>
            NAVIDAD PYME, ASÍ COMO SUS ORGANIZADORES, COLABORADORES Y SPONSORS
            NO ASUMEN NI PUEDEN TENER ALGUNA RESPONSABILIDAD FRENTE A LO
            ANTERIOR, NI TAMPOCO DAN GARANTÍAS A ESTE RESPECTO.
          </strong>{" "}
        </p>
        <p style={{ marginBottom: 10 }}>
          <strong>Reclamos:</strong> Para reclamos y consultas sobre una compra,
          diríjase al servicio al cliente o &quot;contacto&quot; de la Empresa
          Participante donde se realizó la transacción. Navidad Pyme no cuenta
          con funcionarios de servicio al cliente para compras realizadas en las
          Empresas Participantes. Medios de Pago: Cada Empresa Participante
          dispondrá de los medios de pago respectivos.
        </p>
        <p style={{ marginBottom: 10 }}>
          <strong>Fallas en las páginas web</strong>: En caso de páginas caídas
          o fallas en las mismas, es responsabilidad e cada Empresa
          Participante. Navidad Pyme, así como sus organizadores, colaboradores
          y sponsors no asumen ni pueden tener alguna responsabilidad frente a
          lo anterior, ni tampoco dan garantías a este respecto.
        </p>
      </main>
    </div>
    <Footer />
  </div>
)

export default Terminos
